import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Footer} from "../../../_common/components/Footer/Footer";

export const ProjectsFooter = () => {
  const {count} = useSelector(
    (state) => ({count: state.projects.totalCount}),
    shallowEqual
  );

  return <Footer count={count}/>
};
